// getRequestData()
const OrderRequest = class {
  constructor({
    sheetKey,
    accessToken,
    userName,
    userEmail,
    sessionId,
    afid,
    adid,
    amount,
    deliveryCharge,
    discountAmount,
    products,
    options,
    paymentDetail,
    subPaymentMethods,
    shopId,
    phoneNumber,
    deliveryMemo,
    deliveryAddress,
    useSafeNumber,
    cartDiscount,
    couponDiscounts,
    baeminGiftcards,
    cashReceipt,

    reservation = false,
    promiseDeliveryHour,
    promiseDeliveryMinute,
    promiseDeliveryLimitHour,
    promiseDeliveryLimitMinute
  }) {
    this.sheetKey = sheetKey
    this.accessToken = accessToken
    this.userName = userName
    this.userEmail = userEmail
    this.sessionId = sessionId
    this.afid = afid
    this.adid = adid
    this.amount = amount
    this.deliveryCharge = deliveryCharge
    this.discountAmount = discountAmount
    this.products = products
    this.options = options
    this.paymentDetail = paymentDetail
    this.subPaymentMethods = subPaymentMethods
    this.shopId = shopId
    this.phoneNumber = phoneNumber
    this.deliveryMemo = deliveryMemo
    this.deliveryAddress = deliveryAddress
    this.useSafeNumber = useSafeNumber
    this.cartDiscount = cartDiscount
    this.couponDiscounts = couponDiscounts
    this.baeminGiftcards = baeminGiftcards
    this.cashReceipt = cashReceipt

    this.reservation = reservation
    this.promiseDeliveryHour = promiseDeliveryHour
    this.promiseDeliveryMinute = promiseDeliveryMinute
    this.promiseDeliveryLimitHour = promiseDeliveryLimitHour
    this.promiseDeliveryLimitMinute = promiseDeliveryLimitMinute
  }
}

export default null

export const ofOrderRequest = (params = {}) => new OrderRequest(params)

const hasWhiteSpacePattern = /\s/
const invalidStringPattern = /[^a-zA-Z0-9@_.-]/
const emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
export const notValidPattern = /[^a-zA-Zㄱ-ㅎㅏ-ㅣ가-힣0-9;:,.?!\-_()*%#\s]/gim
export const phoneValidPattern = /[^0-9\s]/gim

export const validateUserEmail = email => {
  if (_.isEmpty(email)) {
    return '이메일을 입력 해 주세요'
  }
  if (hasWhiteSpacePattern.test(email)) {
    return '이메일은 띄어쓰기가 불가합니다.'
  }
  if (invalidStringPattern.test(email)) {
    return '이메일은 영문, 숫자, @, _, ., - 만 입력 가능합니다.'
  }
  if (!emailPattern.test(email)) {
    return '이메일 형식으로 입력 해 주세요.'
  }

  return true
}

// src/v2-store/legacy/legacy.js:136
export const validatePhoneNumber = phoneNumber => {
  if (typeof phoneNumber !== 'string') return false

  const isOnlyNumber = !/\D/.test(phoneNumber)
  const isStartWithPhoneNumberPrefix = /^01/.test(phoneNumber)
  const len = phoneNumber.length
  const isPhoneNumberLength = len === 10 || len === 11

  return isOnlyNumber && isStartWithPhoneNumberPrefix && isPhoneNumberLength
}

// src/v2-store/legacy/legacy.js:144
export const validateDeliveryDetailAddress = detailAddress => {
  if (typeof detailAddress !== 'string') return false

  const overZero = detailAddress.trim().length > 0

  // TODO 부정어의 부정 사용 개선
  return overZero && !notValidPattern.test(detailAddress)
}

export const validateDeliveryMemo = memo => {
  if (typeof memo !== 'string') return false

  return !notValidPattern.test(memo)
}
